import { render, staticRenderFns } from "./MobileDetected.vue?vue&type=template&id=70c897b6"
import script from "./MobileDetected.vue?vue&type=script&lang=js"
export * from "./MobileDetected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports